module.exports = __webpack_public_path__ + "static/media/agl.71ef575d.png";